import { render, staticRenderFns } from "./organization-profile.vue?vue&type=template&id=c46948e2&"
import script from "./organization-profile.vue?vue&type=script&lang=js&"
export * from "./organization-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports